export const PROFILE_MEDIA_TYPES = {
  avatar: 'avatar',
  sticker: 'sticker'
} as const
